module.exports = __webpack_public_path__ + "img/max_compliance_logo.b27546ef.jpeg";